const FETCH_GOP = 'dofe-fo/ORGANIZATIONS/FETCH_GOP'
const FETCH_GOP_SUCCESS = `${FETCH_GOP}_SUCCESS`
const FETCH_GOP_FAIL = `${FETCH_GOP}_FAIL`


const GET_ORG_CLIENT_CUSTOMIZATION = 'dofe-fo/ORGANIZATIONS/GET_ORG_CLIENT_CUSTOMIZATION'
const GET_ORG_CLIENT_CUSTOMIZATION_SUCCESS = `${FETCH_GOP}GET_ORG_CLIENT_CUSTOMIZATION_SUCCESS`
const GET_ORG_CLIENT_CUSTOMIZATION_FAIL = `${FETCH_GOP}GET_ORG_CLIENT_CUSTOMIZATION_FAIL`

const initialState = {
  loading: false,
  loaded: false,
  loadingGop: false,
  list: [],
  gopList: [],
  customization: {}
}

export default function reducer (state = initialState, action = {}) {
  switch (action.type) {
    case FETCH_GOP:
      return {
        ...state,
        loadingGop: true
      }
    case FETCH_GOP_SUCCESS:
      return {
        ...state,
        loadingGop: false,
        gopList: action.result || []
      }
    case FETCH_GOP_FAIL:
      return {
        ...state,
        loadingGop: false
      }
    case GET_ORG_CLIENT_CUSTOMIZATION:
      return {
        ...state,
        loading: true
      }
    case GET_ORG_CLIENT_CUSTOMIZATION_SUCCESS:
      return {
        ...state,
        loading: false,
        loaded: true,
        customization: action.result || {}
      }
    case GET_ORG_CLIENT_CUSTOMIZATION_FAIL:
      return {
        ...state,
        loading: false,
        loaded: false,
        error: action.error
      }
    default:
      return state
  }
}


export function fetchGlobalOperatingPartner () {
  return {
    types: [FETCH_GOP, FETCH_GOP_SUCCESS, FETCH_GOP_FAIL],
    promise: client =>
      client.get(
        `api/award-unit-registrations/global-operating-partners`,
        {
          removeToken: true
        }
      )
  }
}

export function fetchSubGlobalOperatingPartner (gopId) {
  return {
    types: [FETCH_GOP, FETCH_GOP_SUCCESS, FETCH_GOP_FAIL],
    promise: client =>
      client.get(
        `api/award-unit-registrations/sub-global-operating-partners/${gopId}`,
        {
          removeToken: true
        }
      )
  }
}

export function getOrganizationClientCustomization (filter) {
  return {
    types: [GET_ORG_CLIENT_CUSTOMIZATION, GET_ORG_CLIENT_CUSTOMIZATION_SUCCESS, GET_ORG_CLIENT_CUSTOMIZATION_FAIL],
    promise: client =>
      client.get(
        `api/organization-client-customization/home-page/get?filter=${filter}`,
        {
          removeToken: true
        }
      )
  }
}

